import React, {Component} from 'react';
import {current,dispatcherlist} from "../../../../service/homeService";
import {driverList,lineList} from "../../../../service/shiftService";
import './index.less';
import {connect} from "react-redux";
import moment from 'moment';
import {Accordion,Toast,Icon,ListView,PullToRefresh,Picker,DatePicker} from 'antd-mobile';

const black = require('../../../../common/image/black.png');
const noShift = require('../../../../common/image/noShift.png');
const dataError = require('../../../../common/image/wrongData.png');
let pageIndex = 1;
let pageSize = 20;
let lineName = '';
let startDate = moment(new Date()).format('YYYY-MM-DD');
let driverName = '';
const now = new Date();
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class InterCity extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            dataSource,
            isLoading: true,
            notDataLoading:0,
            InterCityData:[],
            refreshing: true,
            lineData:[],
            driverData:[],
            lineModal:false,
            dateModal:false,
            driverModal:false,
            lineClass:lineName === '' ? '全部起止区域' : lineName,
            dateTime:startDate === '' ? '全部时间' : startDate,
            driverName:driverName === ''? '全部司机' : driverName,
            vdate:now,
        };
    }
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                source:6,
                lineName:this.state.lineClass === '全部起止区域' ? '' : this.state.lineClass,
                startDate:this.state.dateTime === '全部时间' ? '' : moment(this.state.dateTime).format('YYYY-MM-DD'),
                driverName:this.state.driverName === '全部司机' ? '' : this.state.driverName,
            }
        };
       this.getInterCityData(params);
       //获取筛选数据
       this.getLineData();
       this.getDriverData();
    }
     //获取起止区域数据
     getLineData(){
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "dispatcherId": this.props.userInfo.userId
            }
            
        };
        lineList(params)
            .then((res) => {
                if (res.data.code === '0000') {
                  let lineData = []
                  lineData.push({
                    label:"全部起止区域",
                    value:"全部起止区域",
                  })
                  let data = res.data.data
                  for(let i in data){
                    let temp = data[i];
                    lineData.push({
                      label:temp.name,
                      value:temp.name,
                      id:temp.id
                    })
                  }
                  this.setState({
                    lineData:lineData
                  })
                }
                else if (res.data.code === '1401') {
                  document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
      };
    //获取司机数据
    getDriverData(){
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "dispatcherId": this.props.userInfo.userId,
                "businessType":1,
            }
        };
        driverList(params)
            .then((res) => {
                if (res.data.code === '0000') {
                  let driverData = []
                  driverData.push({
                    label:"全部司机",
                    value:"全部司机",
                  })
                  let data = res.data.data
                  for(let i in data){
                    let temp = data[i];
                    driverData.push({
                      label:temp.name,
                      value:temp.name,
                      id:temp.id
                    })
                  }
                  this.setState({
                    driverData:driverData
                  })
                }
                else if (res.data.code === '1401') {
                  document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
      };
  
    onRefresh = () => {
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                source:6,
                lineName:this.state.lineClass === '全部起止区域' ? '' : this.state.lineClass,
                startDate:this.state.dateTime === '全部时间' ? '' : moment(this.state.dateTime).format('YYYY-MM-DD'),
                driverName:this.state.driverName === '全部司机' ? '' : this.state.driverName,
            }
        };
        pageIndex = 1;
        this.setState({ refreshing: true,isLoading: true, InterCityData:[]});
        // setTimeout(() => {
          this.getInterCityData(params,'refresh');
        //   Toast.info('刷新成功！')
        // }, 2000);
    };
    //城际出行数据
    getInterCityData(params,type){
        this.setState({ notDataLoading:0});
        dispatcherlist(params).then((res) => {
            if(res.data.code == "0000"){
                if(type == 'refresh'){
                    Toast.info('刷新成功！')
                }
                // if (res.data.data.length.list > 0) {
                if (res.data.data.length > 0) {
                    this._setDataSource(res.data.data);
                    // this.setState({notDataLoading:0});
                }else{
                    this.setState({isLoading: false,notDataLoading:1});
                }
            }else {
                this.setState({notDataLoading:2,isLoading: false});
                Toast.info(res.data.msg,3)
            }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        // const allData = [...this.state.InterCityData, ...data.list];
        const allData = [...this.state.InterCityData, ...data];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            InterCityData: allData,
            refreshing: false,
        });
        // if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        // }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex,
                    source:6,
                    lineName:this.state.lineClass === '全部起止区域' ? '' : this.state.lineClass,
                    startDate:this.state.dateTime === '全部时间' ? '' : moment(this.state.dateTime).format('YYYY-MM-DD'),
                    driverName:this.state.driverName === '全部司机' ? '' : this.state.driverName,
                },
            };
            this.getInterCityData(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noShift} />
                        <p>暂无行程，请添加行程</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    showModal = (v,k,j) =>{
        if(j === 'dateTime'){
            this.setState({
                [k]:false,
                dateTime: moment(v).format('YYYY-MM-DD'),
                vdate:v
            })

        }else{
            this.setState({
                [k]:false,
                [j]:v.join()
            })
        }
        pageIndex = 1;
        let top = document.getElementsByClassName("am-list-view-scrollview")
        if( top[0]){
            top[0].scrollTop = 0;
        }
        this.setState({InterCityData:[],isLoading:true,dataSource:this.state.dataSource.cloneWithRows([])})
        lineName = ( j == "lineClass" ? ( v.join() === '全部起止区域' ? '':v.join() ): (this.state.lineClass === '全部起止区域' ? '' : this.state.lineClass))
        startDate = ( j == "dateTime" ? moment(v).format('YYYY-MM-DD') : this.state.dateTime === '全部时间' ? '' : moment(this.state.dateTime).format('YYYY-MM-DD'))
        driverName = ( j == "driverName" ? (v.join() === '全部司机' ? '' : v.join()): (this.state.driverName === '全部司机' ? '' : this.state.driverName) )
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                source:6,
                lineName:lineName,
                startDate:startDate,
                driverName:driverName,
            }
        };
        this.getInterCityData(params);
    }
    render() {
        const _renderRow = (i, index, rowID) => (
            <Accordion  defaultActiveKey={0} className="my-accordion">
                <Accordion.Panel key={index} header={i.startDate+'    '+i.weekend+'    '+i.startCity+'—'+i.endCity}>
                    <div className='boxdiv'>
                        {
                            i.shiftListResults.map((res)=>(
                                <div className={res.remainSeats == 1 ? 'box boxyiman':'box'}  key={res.id} onClick={()=>this.props.goDetail(res.id)}>
                                    <div className='left'>
                                        <div className='time'>{res.startTime}</div>
                                        <div className='name'>{res.driverName}</div>
                                        <div className='carnum'>{res.carNum}</div>
                                    </div>
                                    <div className='right'>
                                        <div>已购:<span className='num'>{res.sold}人</span>{res.remainSeats == 1?<span className='man'>(满)</span>:null}</div>
                                        {res.sold == 0 ? <div className="btn" onClick={(e)=>this.props.modalShow(e,res.id)}>取消行程</div>:null}
                                    </div>
                                </div>
                            ))
                        }
                        
                    </div>
                </Accordion.Panel>
            </Accordion>
            // <div className="cardBox" key={i.id} onClick={()=>this.props.goDetail(i.id)}>
            //     <div className="header">
            //         <div>行程编号  {i.shiftNum}</div>
            //         <div>待出行</div>
            //     </div>
            //     <div className="body">
            //         <div>{i.startCity}</div>
            //         <div className="content">{i.startDate} {i.weekend} {i.startTime}<div className="img"><img src={black}/></div></div>
            //         <div>{i.endCity}</div>
            //     </div>
            //     <div className="footer">
            //         <div>{i.driverName}  <span>{i.carNum}</span></div>
            //         <div>已购：<span>{i.sold}</span></div>
            //         {i.sold == 0 ? <div className="btn" onClick={(e)=>this.props.modalShow(e,i.id)}>取消行程</div>:<div></div>}
            //     </div>
            // </div>
        )
        return (
            <div className="indexScreen">
                <div className="filter">
                    <div className="paddingLeft10" onClick={()=>this.setState({lineModal:!this.state.lineModal})}>{this.state.lineClass} <i className="icon iconfont iconzhandianxialaxuanze"></i></div>
                    <div onClick={()=>this.setState({dateModal:!this.state.dateModal})}>{this.state.dateTime} <i className="icon iconfont iconzhandianxialaxuanze"></i></div> 
                    <div className="paddingRight10" onClick={()=>this.setState({driverModal:!this.state.driverModal})}>{this.state.driverName} <i className="icon iconfont iconzhandianxialaxuanze"></i></div> 
                </div>
                
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                        
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                // renderSectionWrapper={sectionID => (
                                //     <Accordion
                                //       className="my-accordion"
                                //     >{sectionID}111111111111</Accordion>
                                //   )}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto',
                                    fontSize:'12px'
                                }}
                                // onEndReached={this._onEndReached.bind(this)}
                                // scrollRenderAheadDistance={500}
                                // onEndReachedThreshold={30}
                                initialListSize={200000}
                                pullToRefresh={<PullToRefresh
                                refreshing={this.state.refreshing}
                                onRefresh={this.onRefresh}/>}
                            />: null
                    }  
                </div>   
                <Picker
                        cols={1}
                        extra={'选择起止区域'}
                        visible={this.state.lineModal}
                        data={this.state.lineData}
                        onDismiss={()=>this.setState({lineModal:false})}
                        onOk={(v) =>this.showModal(v, 'lineModal','lineClass')}
                ></Picker>
                <DatePicker
                        extra={'选择日期'}
                        onOk={(v) =>this.showModal(v, 'dateModal','dateTime')}
                        // defaultDate={new Date()}
                        minDate={new Date(+now - 10084000000)}
                        visible={this.state.dateModal}
                        mode="date"
                        value={this.state.vdate}
                        maxDate={new Date(+now + 5184000000)}
                        onDismiss={()=>this.setState({dateModal:false})}
                        // onChange={(v)=>this.setState({dateTime:v})}
                    >
                </DatePicker>
                <Picker
                    cols={1}
                    extra={'选择司机'}
                    visible={this.state.driverModal}
                    data={this.state.driverData}
                    onDismiss={()=>this.setState({driverModal:false})}
                    onOk={(v) =>this.showModal(v, 'driverModal','driverName')}
                ></Picker>
                <div className='bottom'>
                    <div className="bottomBtn" onClick={()=>this.props.goPage('shuntOrder',{shuntType:1})}>分流下单</div>
                    <div className="bottomBtn" onClick={()=>this.props.goPage('addShift')}>添加行程</div>
                </div>   
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/InterCity/index.js